import React from "react";

interface ImageViewerProps {
  imagen?: Uint8Array | string; // Puede ser Uint8Array (legacy), string (URL o base64)
  tieneImagen?: boolean;
  className?: string;
}

export const ImageViewer: React.FC<ImageViewerProps> = ({
  imagen,
  tieneImagen = false,
  className = "",
}) => {
  if (!tieneImagen || !imagen) {
    return null;
  }

  let dataUrl: string;

  if (typeof imagen === "string") {
    // Si es string, puede ser URL o base64
    if (imagen.startsWith("http") || imagen.startsWith("https")) {
      // Es una URL
      dataUrl = imagen;
    } else {
      // Es base64
      dataUrl = imagen;
    }
  } else {
    // Si es Uint8Array (legacy), convertir a base64
    try {
      // Asegurar que es un Uint8Array válido
      const bytes =
        imagen instanceof Uint8Array
          ? imagen
          : new Uint8Array(Object.values(imagen));

      const binaryString = Array.from(bytes)
        .map((byte) => String.fromCharCode(byte))
        .join("");
      const base64 = btoa(binaryString);
      dataUrl = `data:image/jpeg;base64,${base64}`;
    } catch (error) {
      // Fallback: intentar con Blob
      try {
        const blob = new Blob([imagen], { type: "image/jpeg" });
        dataUrl = URL.createObjectURL(blob);
      } catch (blobError) {
        return <div className="text-red-500">Error al cargar imagen</div>;
      }
    }
  }

  return (
    <div className={`relative ${className}`}>
      <img
        src={dataUrl}
        alt="Imagen de la pregunta"
        className="max-w-full h-auto rounded-lg shadow-md"
        style={{ maxHeight: "300px" }}
        onError={(e) => {
          // Mostrar un mensaje de error en lugar de ocultar
          e.currentTarget.style.display = "none";
          const errorDiv = document.createElement("div");
          errorDiv.className = "text-red-500 text-sm p-2 bg-red-50 rounded";
          errorDiv.textContent = "Error al cargar imagen";
          e.currentTarget.parentNode?.appendChild(errorDiv);
        }}
      />
    </div>
  );
};
